import "core-js/modules/es.array.push.js";
import common from "./../../common/common.js";
import store from './../store/index.js';
export default {
  name: 'menuLeft',
  components: {},
  data: function () {
    return {
      //clientHeight:'',
      //tabValue:'',
      //is_path:'',
    };
  },
  props: {
    clientHeight: {
      type: String,
      value: ''
    },
    isCollapse: {
      type: Boolean,
      value: false
    },
    menuLeftWidth: {
      type: String,
      value: ''
    },
    isNest: {
      type: Boolean,
      default: false
    },
    routes: {
      type: Array
    }
  },
  created: function () {
    store.commit('addTabs', {
      title: this.$route.meta.title,
      name: this.$route.path
    });
    //console.log('this.$route.path',this.$route.path);
  },

  computed: {
    is_path: {
      get: function () {
        var is_path = store.state.is_path;
        if (!is_path) {
          return this.$route.path;
        }
        return is_path;
      }
    }
  },
  methods: {
    goPage: function (page, name) {
      store.commit('addTabs', {
        title: name,
        name: page
      });
      //console.log('page',page);
      page = page.indexOf('?') != -1 ? page : page + '?rand=' + common.randStr(3);
      this.$router.push(page);
    },
    handleOpen: function () {},
    handleClose: function () {}
  }
};